import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {SettingsProvider} from "./contexts/SettingsContext";

// Register only the merged PWA+FCM service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(function(registration) {
        console.log('Service Worker registered with scope:', registration.scope);
      }).catch(function(err) {
        console.error('Service Worker registration failed:', err);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <SettingsProvider>
            <App/>
    </SettingsProvider>
);
